export const DASHBOARD_DEFAULT = 'DEFAULT';
export const USER_DASHBOARD = 'USER_DASHBOARD';
export const SETTINGS_DASHBOARD = 'SETTINGS_DASHBOARD';
export const OPERATOR_DASHBOARD = 'OPERATOR_DASHBOARD';
export const DEVICE_DASHBOARD = 'DEVICE_DASHBOARD';
export const LICENSE_VIEW = 'LICENSE_VIEW';
